var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0" },
    [
      _c("p-add-package-popup", {
        ref: "p-add-package-popup",
        on: { "show-p-file-preview-popup": _vm.onPreviewPackage },
      }),
      _c("p-file-preview-popup", { ref: "p-file-preview-popup" }),
      _c("p-packages-deploy-popup", { ref: "p-packages-deploy-popup" }),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card",
            {
              staticClass: "ma-0 pa-0",
              attrs: { width: "100%", elevation: "0", outlined: "" },
            },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text pl-5 pr-3",
                      attrs: {
                        disabled: !_vm.ifCanCreateNewPackage(),
                        color: "blue",
                        elevation: "0",
                      },
                      on: { click: _vm.addNewPackage },
                    },
                    [
                      _vm._v(" NEW PACKAGE "),
                      _c("v-icon", { staticClass: "ml-2" }, [
                        _vm._v("mdi-plus"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0 mt-2" },
        [
          _c(
            "v-card",
            {
              staticClass: "ma-0 pa-0",
              attrs: { elevation: "0", width: "100%", outlined: "" },
            },
            [
              _c("v-data-table", {
                staticStyle: { width: "100%" },
                attrs: {
                  "fixed-header": "",
                  items: _vm.packages,
                  headers: _vm.headers,
                  "hide-default-footer": "",
                  "disable-pagination": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.updated",
                    fn: function ({ item }) {
                      return [
                        _c("v-card-text", [
                          _vm._v(_vm._s(_vm._f("formatDate")(item.updated))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanEditPackage(),
                                                icon: "",
                                                color: "green",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressEdit(
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-pencil")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Edit Package")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanDeletePackage(),
                                                loading: _vm.deleting.includes(
                                                  item.id
                                                ),
                                                icon: "",
                                                color: "red",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressDelete(
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Delete Package")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanActivatePackage(),
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressActivate(
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [
                                              _vm._v(
                                                "mdi-arrow-right-thin-circle-outline"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Activate package")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }